import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataCreate = parseToMutationRequest(data, ['index', 'price', 'eightHundredFlag']);
  const createSpecialPrice = `createSpecialPrice(input: ${dataCreate})`;
  return gql`
  mutation {
    ${createSpecialPrice} {
      id
    }
  }
`;
};
